const initialState = {
    graceNote: {response: null, error: null},
    graceNoteGuids: [],
    echostarIds: [],
};

const actions = {
    SEND_TO_GRACE_NOTE_REJECTED: (state, {error}) => ({
        ...state,
        graceNote: {error},
    }),

    SEND_TO_GRACE_NOTE_FULFILLED: (state, {response}) => ({
        ...state,
        graceNote: {response, error: null},
    }),

    ADD_MASS_GUID_FOR_GRACE_NOTE: (state, {guids}) => ({
        ...state,
        graceNoteGuids: guids,
    }),

    CLEAR_BULK_EIDS: () => ({
        ...initialState,
    }),

    CLEAR_GRACE_NOTE_RESPONSE: (state) => ({
        ...state,
        // eslint-disable-next-line react/destructuring-assignment
        graceNote: {response: null, error: state?.graceNote?.error},
    }),

    CONVERT_GUIDS_FULFILLED: (state, {response}) => {
        const {content} = response || [];
        const {echostarIds} = state;
        const temp = [...echostarIds];
        if (Array.isArray(content) && content.length>0) {
            const {echostarId} = content[0]?.amsFranchise !== null
                    ? content[0]?.amsFranchise
                    : content[0]?.amsEpisode || {echostarId: null};
            temp.push(echostarId);
        }
        return {
            ...state,
            echostarIds: [...new Set(temp)],
        };
    },
};

const reducer = (state = initialState, action) => (actions[action.type] ? actions[action.type](state, action) : state);

export default reducer;
